import {
  LayoutDashboard, Users, Car, ClipboardCheck, Wrench, FileText, ShieldCheck, Package, Truck, BarChart3,
  Building2, GitBranch, UserCog, KeyRound, ScrollText, Boxes, BookOpen, IdCard, HardHat, History, CheckSquare, Database,
} from "lucide-react";

const item = (key, label, icon, path, perm) => ({ key, label, icon, path, perm });

export const MAIN_NAV = [
  item("dashboard", "Dashboard", LayoutDashboard, "/", "dashboard.view"),
  item("garage-vehicles", "Vehicles", Car, "/garage-vehicles", "vehicle.view"),
  item("service-records", "Service", Wrench, "/service-records", "maintenance.view"),
  item("service-timeline", "Service Timeline", History, "/service-timeline", "maintenance.view"),
  item("stock", "Spare Parts", Package, "/stock", "inventory.view"),
  item("expenses", "Expenses", BarChart3, "/expenses", "report.view"),
];

export const SETTINGS_GROUPS = [
  {
    label: "Garage",
    items: [
      item("service-approvals", "Approvals", CheckSquare, "/service-approvals", "maintenance.view"),
      item("vehicles", "Vehicle Records", Database, "/vehicles", "vehicle.view"),
      item("parts", "Parts Catalog", Boxes, "/parts", "parts.view"),
      item("vendors", "Vendors & Garages", Truck, "/vendors", "vendor.view"),
      item("drivers", "Drivers", IdCard, "/drivers", "driver.view"),
      item("customers", "Customers", Users, "/customers", "customer.view"),
      item("fleets", "Fleets", Truck, "/fleets", "vehicle.view"),
      item("service-catalog", "Service Catalog", BookOpen, "/service-catalog", "catalog.view"),
    ],
  },
  {
    label: "Company & access",
    items: [
      item("companies", "Companies", Building2, "/admin/companies", "company.view"),
      item("branches", "Branches & Workshops", GitBranch, "/admin/branches", "branch.view"),
      item("users", "Users", UserCog, "/admin/users", "user.view"),
      item("roles", "Roles & Permissions", KeyRound, "/admin/roles", "role.view"),
      item("audit", "Audit Logs", ScrollText, "/admin/audit", "audit.view"),
    ],
  },
  {
    label: "Advanced",
    items: [
      item("check-in", "Check-In & Requests", ClipboardCheck, "/check-in", "checkin.view"),
      item("quotations", "Quotations", FileText, "/quotations", "quotation.view"),
      item("job-cards", "Job Cards", Wrench, "/job-cards", "jobcard.view"),
      item("approvals", "Approval Center", ShieldCheck, "/approvals", "approval.view"),
      item("approval-policies", "Approval Policies", ShieldCheck, "/admin/approval-policies", "approval.view"),
      item("technicians", "Technicians", HardHat, "/technicians", "workforce.view"),
    ],
  },
];

export const ALL_NAV = [
  ...MAIN_NAV.map((i) => ({ ...i, group: "Main" })),
  ...SETTINGS_GROUPS.flatMap((g) => g.items.map((i) => ({ ...i, group: "Settings" }))),
];

export function findNav(pathname) {
  if (pathname === "/") return ALL_NAV[0];
  if (pathname === "/settings") return { key: "settings", label: "Settings", path: "/settings", group: "Main" };
  return ALL_NAV.filter((i) => i.path !== "/" && (pathname === i.path || pathname.startsWith(`${i.path}/`)))
    .sort((a, b) => b.path.length - a.path.length)[0];
}
